(function(){
  if(!document.getElementById('cal-m1')) return;
  var s=null,e=null;
  var today=new Date(); today.setHours(0,0,0,0);
  var vy=today.getFullYear(), vm=today.getMonth();
  function fmt(d){
  var dd=String(d.getDate()).padStart(2,'0');
  var mm=String(d.getMonth()+1).padStart(2,'0');
  return dd+'.'+mm+'.'+d.getFullYear();
}


  var btn=document.createElement('button');
  btn.id='cal-checkout-btn';
  btn.textContent='Zamów ofertę';
  btn.style.cssText='margin:14px auto 0 auto;background:#0094d9;color:#fff;font-size:15px;font-weight:800;border-radius:25px;padding:14px 20px;text-align:center;border:none;cursor:pointer;width:60%;box-sizing:border-box;display:none;';
  btn.onmouseover=function(){this.style.background='#007ab8';};
  btn.onmouseout=function(){this.style.background='#0094d9';};
    btn.onclick=function(){
    var terminVal=document.getElementById('termin-choice-input')?document.getElementById('termin-choice-input').value:'';
    var hotelVal=document.getElementById('hotel-choice-input')?document.getElementById('hotel-choice-input').value:'Oferta';
    var airportVal=document.getElementById('airport-choice-input')?document.getElementById('airport-choice-input').value:'Oferta';
    var paxVal=document.getElementById('pax-choice-input')?document.getElementById('pax-choice-input').value:'2';
    var variantId=document.querySelector('input[name="id"]')?document.querySelector('input[name="id"]').value:'';
    fetch('/cart/clear.js',{method:'POST'}).then(function(){
      var fd=new FormData();
      fd.append('items[0][id]',variantId);
      fd.append('items[0][quantity]','1');
      fd.append('items[0][properties][Zakwaterowanie]',hotelVal);
      fd.append('items[0][properties][Lotnisko]',airportVal);
      fd.append('items[0][properties][Liczba osób]',paxVal);
      fd.append('items[0][properties][Wybrany termin]',terminVal);
      fetch('/cart/add.js',{method:'POST',body:fd}).then(function(){
        window.location.href='/checkout';
      });
    });
  };


  function render(id,y,m){
    var el=document.getElementById(id); if(!el) return;
    var mn=['Styczeń','Luty','Marzec','Kwiecień','Maj','Czerwiec','Lipiec','Sierpień','Wrzesień','Październik','Listopad','Grudzień'];
    var fd=new Date(y,m,1).getDay(); fd=(fd+6)%7;
    var dim=new Date(y,m+1,0).getDate();
    var h='<div class="cal-month-header">';
    h+=(id==='cal-m1'?'<button class="cal-nav" onclick="calNav(-1)">&#8249;</button>':'<span style="width:24px"></span>');
    h+='<span class="cal-month-title">'+mn[m]+' '+y+'</span>';
    h+=(id==='cal-m2'?'<button class="cal-nav" onclick="calNav(1)">&#8250;</button>':'<span style="width:24px"></span>');
    h+='</div><div class="cal-grid">';
    ['Pn','Wt','Śr','Cz','Pt','So','Nd'].forEach(function(n){h+='<div class="cal-dow">'+n+'</div>';});
    for(var i=0;i<fd;i++) h+='<div class="cal-day empty"></div>';
    for(var d=1;d<=dim;d++){
      var dt=new Date(y,m,d), c='cal-day';
      if(dt<today) c+=' past';
      else if(s&&dt.getTime()===s.getTime()) c+=' start';
      else if(e&&dt.getTime()===e.getTime()) c+=' end';
      else if(s&&e&&dt>s&&dt<e) c+=' in-range';
      h+='<div class="'+c+'" onclick="calClick('+y+','+m+','+d+')">'+d+'</div>';
    }
    h+='</div>'; el.innerHTML=h;
  }

  function refresh(){
    render('cal-m1',vy,vm);
    var m2=vm+1>11?0:vm+1, y2=vm+1>11?vy+1:vy;
    render('cal-m2',y2,m2);
  }

  window.calNav=function(dir){
    vm+=dir;
    if(vm>11){vm=0;vy++;} if(vm<0){vm=11;vy--;}
    refresh();
  };

  window.calClick=function(y,m,d){
    var dt=new Date(y,m,d);
    if(!s||e||dt<s){s=dt;e=null;}
    else if(dt.getTime()===s.getTime()){s=null;}
    else{e=dt;}
    refresh();
    var sum=document.getElementById('cal-summary');
    var note=document.getElementById('cal-note');
    if(s&&e){
      var days=Math.round((e-s)/(1000*60*60*24));
      document.getElementById('cal-from').textContent=fmt(s);
      document.getElementById('cal-to').textContent=fmt(e);
      document.getElementById('cal-days').textContent=days;
      sum.style.display='block';
      note.style.display='block';
      btn.style.display='block';
      fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:{'Wybrany termin':fmt(s)+' \u2192 '+fmt(e)+' ('+days+' dni)'}})});
      var termInput=document.getElementById('termin-choice-input');
      if(!termInput){
        termInput=document.createElement('input');
        termInput.type='hidden';
        termInput.name='properties[Wybrany termin]';
        termInput.id='termin-choice-input';
        var form=document.querySelector('#buy-now-form');
        if(form) form.appendChild(termInput);
      }
      termInput.value=fmt(s)+' \u2192 '+fmt(e)+' ('+days+' dni)';
    } else {
      sum.style.display='none';
      note.style.display='none';
      btn.style.display='none';
    }
  };

  var wrapper=document.querySelector('.cal-wrapper');
  if(wrapper) wrapper.appendChild(btn);

  refresh();
})();



document.addEventListener('DOMContentLoaded', function(){
  var h = document.getElementById('hotel-choice-input');
  var a = document.getElementById('airport-choice-input');
  var p = document.getElementById('pax-choice-input');
  setTimeout(function(){
    if(h && (!h.value || h.value==='Nie wybrano')) h.value='Podstawowe';
    if(a && (!a.value || a.value==='Nie wybrano')) a.value='Z oferty';
    if(p && (!p.value || p.value==='Nie wybrano' || p.value==='1-2 osoby')) p.value='2';
  }, 500);
});
